import React from 'react'
import Image from '../base-ui/Image'
import { css } from '@emotion/react'
import { Link, Typography } from '../base-ui'
// import { MediaQuery } from '../base-ui/Utility'

function PostCardH({ src, uptitle, title, date, style, href }) {
    const cardStyle = css`
        display: flex;
        height: 7rem;
        flex-wrap: wrap;
        .card-image {
            display: flex;
            justify-content: center;
            align-items: center;
            flex-basis: 25%;
        }
        .content {
            display: flex;
            flex-direction: column;
            flex-basis: ${src ? '75' : '100'}%;
            padding: 1rem;
        }
        ${style}
    `

    // ${MediaQuery('xxl', 'min')} {
    //      padding: 1rem 1rem 1rem 0;
    // }

    const body = (
        <div css={cardStyle}>
            {src && (
                <div className="card-image">
                    <Image
                        noStyle
                        src={src}
                        width={100}
                        height={100}
                        alt="card image"
                        objectFit="cover"
                    />
                </div>
            )}
            <div className="content">
                {uptitle && (
                    <Typography type="t" lineClamp={1}>
                        {uptitle}
                    </Typography>
                )}
                <Typography type="h5" lineClamp={3}>
                    {title}
                </Typography>
                {date && <div>{date}</div>}
            </div>
        </div>
    )
    if (href) return <Link href={href}>{body}</Link>
    return body
}

export default PostCardH
